import * as React from 'react';
import { createFileRoute, redirect, useParams } from '@tanstack/react-router';

import { useCarrier } from '&/features/settings/carriers/hooks';
import { VehiclesPage } from '&/features/settings/vehicles/pages/vehicles-page';
import { useMasterContext } from '&/master';

export const Route = createFileRoute('/_authenticated/settings_/carriers/$carrierId/vehicles')({
  beforeLoad: ({ context, params }): void => {
    if (
      context.permissions.isReady &&
      !context.permissions.hasAnyPermission(['carriers:manage', 'carriers:access-read-only'])
    ) {
      throw redirect({ params: { carrierId: params.carrierId }, to: '/settings/carriers/$carrierId' });
    }
  },
  component: CarrierVehiclesPage,
});

function CarrierVehiclesPage(): React.JSX.Element {
  const { carrierId } = useParams({ from: '/_authenticated/settings_/carriers/$carrierId/vehicles' });
  const { data: carrier } = useCarrier(carrierId);
  const { spaceId: contextSpaceId } = useMasterContext();
  const spaceId = carrier?.spaceId ?? contextSpaceId ?? undefined;
  return <VehiclesPage carrierId={carrierId} scope="carrier" spaceId={spaceId} />;
}
